// @flow

import React, { useMemo } from "react";
import { localize } from "redux-i18n";
import { SectionComponent, GSGrid, TooltipDropdown } from "@components";
import type { SlaAgreement } from "@modules/client/reducer/sla/types";

type Props = $Exact<{
  agreements: SlaAgreement[],
  openModal: (name: string) => void,
  disableEdit?: boolean,
  ...PropsFromLocalize,
}>;

const SlaMeasures = (props: Props) => {
  return (
    <SectionComponent
      classNames="d-flex flex-column gs-shadow"
      wrapper=""
      title={
        <div className="align-items-center">
          <TooltipDropdown
            title={props.t("SLA_MEASURES_PAGE_TITLE")}
            description={props.t("SLA_MEASURES_PAGE_DESCRIPTION")}
            id="sla-measures-page-title"
          >
            <h5>{props.t("SLA_MEASURES")}</h5>
          </TooltipDropdown>
        </div>
      }
    >
      <GSGrid
        noResultsText={props.t("NO_RESULTS_TEXT")}
        rowKeyGetter={(row: SlaAgreement) => row.sla.name}
        rows={props.agreements.filter(row => row.sla.name !== "self-service-reviews")}
        columns={[
          {
            name: props.t("SLA_NAME"),
            key: "sla-name",
            align: "left",
            renderCell: ({ row }: { row: SlaAgreement }) => row.sla.displayName,
          },
          {
            name: props.t("SLA_DESCRIPTION"),
            key: "description",
            align: "left",
            renderCell: ({ row }: { row: SlaAgreement }) => row.sla.description,
          },
          {
            name: props.t("STATUS"),
            key: "status",
            width: 105,
            renderCell: ({ row }: { row: SlaAgreement }) =>
              row.isEnabled ? props.t("ENABLED") : props.t("DISABLED"),
          },
          {
            name: props.t("MEASURE"),
            key: "measure",
            renderCell: ({ row }: { row: SlaAgreement }) =>
              row.measure ? row.measure : props.t("N/A"),
          },
          {
            name: props.t("SLA_TARGET"),
            key: "target",
            renderCell: ({ row }: { row: SlaAgreement }) =>
              row.value ? row.value : props.t("N/A"),
          },
          {
            name: props.t("PERIOD"),
            key: "period",
            align: "left",
            renderCell: ({ row }: { row: SlaAgreement }) =>
              row.period ? props.t(row.period) : props.t("N/A"),
          },
          {
            name: props.t("EDIT"),
            key: "edit",
            width: 50,
            hidden: props.disableEdit,
            onCellClick: (row: SlaAgreement) => props.openModal(row.sla.name),
            renderCell: () => GSGrid.render.materialIcon("edit"),
          },
        ]}
      />
    </SectionComponent>
  );
};

export default localize()(SlaMeasures);
